// State to timezone mapping (IANA timezone strings)
export const stateTimezones: Record<string, { timezone: string; label: string }> = {
  AL: { timezone: "America/Chicago", label: "Central" },
  AK: { timezone: "America/Anchorage", label: "Alaska" },
  AZ: { timezone: "America/Phoenix", label: "Mountain" },
  AR: { timezone: "America/Chicago", label: "Central" },
  CA: { timezone: "America/Los_Angeles", label: "Pacific" },
  CO: { timezone: "America/Denver", label: "Mountain" },
  CT: { timezone: "America/New_York", label: "Eastern" },
  DE: { timezone: "America/New_York", label: "Eastern" },
  FL: { timezone: "America/New_York", label: "Eastern" },
  GA: { timezone: "America/New_York", label: "Eastern" },
  HI: { timezone: "Pacific/Honolulu", label: "Hawaii" },
  ID: { timezone: "America/Boise", label: "Mountain" },
  IL: { timezone: "America/Chicago", label: "Central" },
  IN: { timezone: "America/Indiana/Indianapolis", label: "Eastern" },
  IA: { timezone: "America/Chicago", label: "Central" },
  KS: { timezone: "America/Chicago", label: "Central" },
  KY: { timezone: "America/New_York", label: "Eastern" },
  LA: { timezone: "America/Chicago", label: "Central" },
  ME: { timezone: "America/New_York", label: "Eastern" },
  MD: { timezone: "America/New_York", label: "Eastern" },
  MA: { timezone: "America/New_York", label: "Eastern" },
  MI: { timezone: "America/Detroit", label: "Eastern" },
  MN: { timezone: "America/Chicago", label: "Central" },
  MS: { timezone: "America/Chicago", label: "Central" },
  MO: { timezone: "America/Chicago", label: "Central" },
  MT: { timezone: "America/Denver", label: "Mountain" },
  NE: { timezone: "America/Chicago", label: "Central" },
  NV: { timezone: "America/Los_Angeles", label: "Pacific" },
  NH: { timezone: "America/New_York", label: "Eastern" },
  NJ: { timezone: "America/New_York", label: "Eastern" },
  NM: { timezone: "America/Denver", label: "Mountain" },
  NY: { timezone: "America/New_York", label: "Eastern" },
  NC: { timezone: "America/New_York", label: "Eastern" },
  ND: { timezone: "America/Chicago", label: "Central" },
  OH: { timezone: "America/New_York", label: "Eastern" },
  OK: { timezone: "America/Chicago", label: "Central" },
  OR: { timezone: "America/Los_Angeles", label: "Pacific" },
  PA: { timezone: "America/New_York", label: "Eastern" },
  RI: { timezone: "America/New_York", label: "Eastern" },
  SC: { timezone: "America/New_York", label: "Eastern" },
  SD: { timezone: "America/Chicago", label: "Central" },
  TN: { timezone: "America/Chicago", label: "Central" },
  TX: { timezone: "America/Chicago", label: "Central" },
  UT: { timezone: "America/Denver", label: "Mountain" },
  VT: { timezone: "America/New_York", label: "Eastern" },
  VA: { timezone: "America/New_York", label: "Eastern" },
  WA: { timezone: "America/Los_Angeles", label: "Pacific" },
  WV: { timezone: "America/New_York", label: "Eastern" },
  WI: { timezone: "America/Chicago", label: "Central" },
  WY: { timezone: "America/Denver", label: "Mountain" },
  DC: { timezone: "America/New_York", label: "Eastern" },
  PR: { timezone: "America/Puerto_Rico", label: "Atlantic" },
};

export interface TimezoneInfo {
  agentTime: string;
  agentTz: string;
  clientTime: string | null;
  clientTz: string | null;
  sameTimezone: boolean;
}

// Helper to format time with timezone info
export const formatTimeWithTimezone = (startTime: string, leadState?: string): TimezoneInfo | null => {
  if (!startTime) return null;
  const date = new Date(startTime);
  const agentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Format in agent's local time
  const agentTimeStr = date.toLocaleString("en-US", {
    timeZone: agentTimezone,
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  const agentTzAbbr = new Intl.DateTimeFormat('en-US', {
    timeZone: agentTimezone,
    timeZoneName: 'short'
  }).formatToParts(date).find(p => p.type === 'timeZoneName')?.value || 'Local';

  if (!leadState || !stateTimezones[leadState]) {
    return { agentTime: agentTimeStr, agentTz: agentTzAbbr, clientTime: null, clientTz: null, sameTimezone: true };
  }

  const tzInfo = stateTimezones[leadState];

  // Format in client's timezone
  const clientTimeStr = date.toLocaleString("en-US", {
    timeZone: tzInfo.timezone,
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  return {
    agentTime: agentTimeStr,
    agentTz: agentTzAbbr,
    clientTime: clientTimeStr,
    clientTz: tzInfo.label,
    sameTimezone: tzInfo.timezone === agentTimezone
  };
};
